import React from 'react';
import ReactMarkdown from 'markdown-to-jsx';

import BEMHelper from '@ynap/bem-helper';
import { useMessages, useAppState } from '@ynap/immutables-provider';

import { LoyaltyBadgeNotificationProps } from './types';

const bem = new BEMHelper('LoyaltyBadgeNotification');

const LoyaltyBadgeNotification = ({ className, tracking, stacked = false, tier = 'guest', withoutLink, isExclusiveBadge }: LoyaltyBadgeNotificationProps) => {
    const messages = useMessages();
    const { locale } = useAppState() || {};
    const notification = messages?.loyalty?.notification({ tier, locale: typeof locale === 'string' ? locale : locale.id, isExclusiveBadge }) || '';

    const handleCTAClick = () => {
        tracking?.trackEvent({
            event: 'select_loyalty_discover_more',
        });
    };

    // For eipplatinum no notification should exist
    if (notification.length === 0) return null;

    return (
        <p className={bem('', `${tier} ${stacked ? 'stacked' : ''}`, className)}>
            <ReactMarkdown
                className={bem('messages')}
                options={{
                    overrides: {
                        // eslint-disable-next-line no-unused-vars
                        a: ({ node, ...props }) => {
                            return withoutLink ? null : (
                                <a {...props} className={bem('link', { stacked })} target="_blank" rel="noopener noreferrer" onClick={handleCTAClick} />
                            );
                        },
                    },
                }}
            >
                {notification}
            </ReactMarkdown>
        </p>
    );
};

export default LoyaltyBadgeNotification;
